var AdaptiveImage = require( "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/btn_onboard_red_envelope.339e6aa8.png","uri@2x": __webpack_public_path__ + "static/media/btn_onboard_red_envelope.579c0dc7.png","uri@3x": __webpack_public_path__ + "static/media/btn_onboard_red_envelope.0a72e289.png",
    width: 89,
    height: 89
});